__webpack_require__.p = "//mak-online.ru/wp-content/reactpress/apps/psy-cards-landing/build/";